import type { PageContext } from 'vike/types';
import { toSafeIntlStringValue } from '../../../utils/intl/to-safe-intl-string-value';
import { buildClampedTitle, clampMetaTitle } from '../../../utils/seo/clamp-meta-title';
import type { Data } from './+data.server';

export default function title(pageContext: PageContext): string {
  const data = ((pageContext as PageContext & { data?: Data }).data ?? {}) as Data | Record<string, never>;
  if (data && 'notFound' in data && data.notFound === true) {
    const loc = data.locale === 'fi' ? 'fi' : data.locale === 'sv' ? 'sv' : 'en';
    if (loc === 'fi') return clampMetaTitle('Yritysprofiilia ei saatavilla | JobCrawls');
    if (loc === 'sv') return clampMetaTitle('Arbetsgivarprofil ej tillgänglig | JobCrawls');
    return clampMetaTitle('Employer profile not available | JobCrawls');
  }
  const metaTitle = (data as { metaTitle?: string }).metaTitle;
  if (metaTitle && typeof metaTitle === 'string') {
    // Clamp existing metaTitle if it exceeds 60 characters
    return clampMetaTitle(metaTitle);
  }
  // Fallbacks. Same two-segment, entity-led pattern as the primary metaTitle path in
  // load-company-profile-page-data.ts (see AGENTS.md's "Documented exception" note): this used
  // to be a three-segment `{Company} | {phrase} | JobCrawls` title, inconsistent with the
  // deliberate two-segment format used everywhere else on this page type.
  const locale = (pageContext as any).locale || 'en';
  const companyRaw = data?.company;
  const company =
    toSafeIntlStringValue(companyRaw?.companyName, locale).trim() ||
    companyRaw?.objectID ||
    data?.companySlug ||
    'Company';
  if (locale === 'fi') {
    return buildClampedTitle([`${company} – Avoimet työpaikat`, 'JobCrawls'], ' | ');
  }
  if (locale === 'sv') {
    return buildClampedTitle([`${company} – Lediga jobb`, 'JobCrawls'], ' | ');
  }
  return buildClampedTitle([`${company} Careers – Open Jobs`, 'JobCrawls'], ' | ');
}
